module.exports = __webpack_public_path__ + "img/tree-05-g-trunk.6df4eafe.png";